/*!
 * hibiya-availability-fix.js  (2026-07-21 v4)
 * 목적: 히비야 location shipsInventory=false 때문에 창고=0·히비야有 상품/사이즈가
 *       테마에서 "売り切れ/在庫切れ(취소선/SOLD OUT배지)"로 표시되는 문제 임시 보정.
 * 안전: Shopify Storefront API가 availableForSale=true 라고 확인한 것만 보정.
 *       진짜품절(false)은 절대 안 건드림. 전부 try/catch + idempotent (스토어프론트 안 깨짐).
 * 범위:
 *   PART A (전 페이지): 컬렉션/검색/추천 카드의 SOLD OUT 배지 숨김(상품단위 availableForSale=true 만).
 *   PART B (상품 상세): 사이즈 취소선 제거 + 구매버튼 활성 + 売り切れ배지 숨김 + 재고표시를
 *                       창고+히비야 합산수량(Storefront quantityAvailable)으로 통일 + hidden id input 활성.
 * 롤백: theme.liquid 로더 1줄 삭제 + 이 에셋 삭제, 또는 백업테마 publish.
 * 근본해결: Shopify 서포트가 日比谷 shipsInventory 활성화하면 이 패치 제거 가능.
 */
(function () {
  "use strict";
  try {
    var TOKEN = "e6cca5b6a86a342ee1e50ed41cea4617"; // diag-hibiya (public storefront token, read-only)
    var API = "/api/2025-01/graphql.json";
    var ICON = '<svg class="icon icon-inventory-status" aria-hidden="true" focusable="false" viewBox="0 0 15 15">' +
      '<circle cx="7.5" cy="7.5" r="7.5" fill="currentColor"/>' +
      '<circle cx="7.5" cy="7.5" r="5" fill="currentColor" stroke="#FFF"/></svg>';
    var IN_STOCK_COLOR = "rgb(238, 148, 65)";
    var SOLD_RE = /^\s*(sold\s*out|売り切れ|完売|品切|在庫切れ)\s*$/i;

    function sf(query) {
      return fetch(API, {
        method: "POST",
        headers: { "Content-Type": "application/json", "X-Shopify-Storefront-Access-Token": TOKEN },
        body: JSON.stringify({ query: query })
      }).then(function (r) { return r.json(); });
    }
    function isSoldText(s) { return /売り切れ|品切|在庫切れ|sold\s*out|完売/i.test(s || ""); }

    // ────────────────────────────────────────────────────────────
    // PART A — 카드 SOLD OUT 배지 (전 페이지)
    // ────────────────────────────────────────────────────────────
    var availByHandle = {};   // handle -> bool
    var queried = {};         // handle -> true

    function collectHandles() {
      var set = {}, out = [];
      var links = document.querySelectorAll('a[href*="/products/"]');
      Array.prototype.forEach.call(links, function (a) {
        var href = a.getAttribute("href") || "";
        var m = href.match(/\/products\/([a-z0-9\-_%]+)/i);
        if (m) { var h = decodeURIComponent(m[1]).toLowerCase(); if (!set[h]) { set[h] = 1; out.push(h); } }
      });
      return out;
    }

    function queryHandles(handles) {
      var todo = handles.filter(function (h) { return !queried[h]; });
      if (!todo.length) return Promise.resolve();
      todo.forEach(function (h) { queried[h] = true; });
      var chunks = [];
      for (var i = 0; i < todo.length; i += 40) chunks.push(todo.slice(i, i + 40));
      return Promise.all(chunks.map(function (chunk) {
        var q = "{" + chunk.map(function (h, i) {
          return "p" + i + ':product(handle:"' + h.replace(/["\\]/g, "") + '"){availableForSale}';
        }).join(" ") + "}";
        return sf(q).then(function (j) {
          var d = (j && j.data) || {};
          chunk.forEach(function (h, i) { var p = d["p" + i]; if (p) availByHandle[h] = !!p.availableForSale; });
        }).catch(function () {});
      }));
    }

    var CARD_SEL = ".card-wrapper, .card, li.grid__item, .grid__item, .product-card, .collection-product-card";
    function fixCards() {
      var links = document.querySelectorAll('a[href*="/products/"]');
      Array.prototype.forEach.call(links, function (a) {
        var href = a.getAttribute("href") || "";
        var m = href.match(/\/products\/([a-z0-9\-_%]+)/i);
        if (!m) return;
        var h = decodeURIComponent(m[1]).toLowerCase();
        if (availByHandle[h] !== true) return; // 미확인/품절 → 안 건드림
        var card = a.closest(CARD_SEL) || a.parentElement;
        if (!card) return;
        // 이 카드 안의 SOLD OUT 배지만 숨김 (SALE/세일 배지는 텍스트로 구분해 보존)
        var badges = card.querySelectorAll(".card__badge, .badge");
        Array.prototype.forEach.call(badges, function (b) {
          if (SOLD_RE.test(b.textContent || "")) {
            var wrap = b.closest(".card__badge") || b;
            if (wrap.style.display !== "none") wrap.style.display = "none";
          }
        });
        if (card.classList && card.classList.contains("card--sold-out")) card.classList.remove("card--sold-out");
      });
    }

    // ────────────────────────────────────────────────────────────
    // PART B — 상품 상세페이지 (사이즈/버튼/재고)
    // ────────────────────────────────────────────────────────────
    var isProduct = false, availValues = null, qtyByValue = {};

    function getHandle() {
      var c = document.querySelector('link[rel="canonical"]');
      var m = c && c.href && c.href.match(/\/products\/([^/?#]+)/);
      if (m) return decodeURIComponent(m[1]);
      var m2 = location.pathname.match(/\/products\/([^/?#]+)/);
      return m2 ? decodeURIComponent(m2[1]) : null;
    }
    function addToCartText() {
      return (window.variantStrings && window.variantStrings.addToCart) || "カートに追加する";
    }
    function rootSel() {
      return document.querySelector('variant-selects[id*="__main"]') || document.querySelector('variant-selects');
    }

    function loadProduct(handle) {
      var q = '{product(handle:"' + handle.replace(/["\\]/g, "") +
        '"){options{name} variants(first:100){edges{node{availableForSale quantityAvailable selectedOptions{name value}}}}}}';
      return sf(q).then(function (j) {
        var p = j && j.data && j.data.product;
        if (!p) return;
        if (!p.options || p.options.length !== 1) { availValues = null; return; } // 다축 오판방지 no-op
        var set = {};
        (p.variants && p.variants.edges || []).forEach(function (e) {
          var n = e.node;
          if (n && n.availableForSale) {
            (n.selectedOptions || []).forEach(function (o) {
              var v = (o.value || "").trim(); set[v] = true;
              if (typeof n.quantityAvailable === "number" && n.quantityAvailable > 0) qtyByValue[v] = n.quantityAvailable;
            });
          }
        });
        availValues = set;
      });
    }

    function currentValue(sel) {
      var c = sel.querySelector('input[type="radio"]:checked');
      return c ? (c.value || "").trim() : null;
    }
    function fixButton(cv) {
      var btn = document.querySelector('[id^="ProductSubmitButton"]') ||
                document.querySelector('product-form [name="add"]') ||
                document.querySelector('form[action*="/cart/add"] [name="add"]');
      if (!btn) return;
      if (btn.disabled) btn.disabled = false;
      if (btn.hasAttribute("disabled")) btn.removeAttribute("disabled");
      var span = btn.querySelector("span");
      if (span && isSoldText(span.textContent)) span.textContent = addToCartText();
      var form = btn.closest("form") || document.querySelector('form[action*="/cart/add"]');
      if (form) {
        var idInput = form.querySelector('input[name="id"]');
        if (idInput && idInput.disabled) idInput.disabled = false;
        if (idInput && idInput.hasAttribute("disabled")) idInput.removeAttribute("disabled");
      }
    }
    function fixDetailBadge() {
      Array.prototype.forEach.call(document.querySelectorAll(".price--sold-out"), function (el) {
        el.classList.remove("price--sold-out");
      });
    }
    function fixInventory(cv) {
      var inv = document.querySelector('[id^="Inventory-"], .product__inventory');
      if (!inv) return;
      var n = qtyByValue[cv];
      // 在庫表示は自作ロジックのティアに合わせる: ≤3=残りN点 / 4-19=残りわずか△ / 20+=在庫あり○
      var label, invColor;
      if (typeof n === "number" && n > 0) {
        if (n <= 3) { label = "残り" + n + "点"; invColor = "rgb(238, 148, 65)"; }
        else if (n < 20) { label = "残りわずか△"; invColor = "rgb(238, 148, 65)"; }
        else { label = "在庫あり○"; invColor = "rgb(62, 214, 96)"; }
      } else { label = "在庫あり○"; invColor = "rgb(62, 214, 96)"; }
      var textEl = inv.querySelector(".product__inventory-text");
      var curText = textEl ? (textEl.textContent || "").trim() : "";
      if (curText === label && !isSoldText(inv.textContent)) return; // idempotent (loop 방지)
      inv.innerHTML = '<span class="svg-wrapper" style="color: ' + invColor + '">' + ICON +
        '</span><span class="product__inventory-text">' + label + '</span>';
    }

    function applyDetail() {
      if (!availValues) return;
      var sel = rootSel(); if (!sel) return;
      var radios = sel.querySelectorAll('input[type="radio"]');
      Array.prototype.forEach.call(radios, function (r) {
        var val = (r.value || "").trim();
        if (availValues[val]) {
          if (r.classList.contains("disabled")) r.classList.remove("disabled");
          if (r.hasAttribute("disabled")) r.removeAttribute("disabled");
        }
      });
      var cv = currentValue(sel);
      if (cv && availValues[cv]) { fixButton(cv); fixDetailBadge(); fixInventory(cv); }
    }

    // ────────────────────────────────────────────────────────────
    // scheduler
    // ────────────────────────────────────────────────────────────
    var raf = null;
    function tick() { raf = null; if (isProduct) applyDetail(); fixCards(); }
    function schedule() { if (raf) return; raf = requestAnimationFrame(tick); }
    function maybeQueryNew() {
      var hs = collectHandles().filter(function (h) { return !queried[h]; });
      if (hs.length) queryHandles(hs).then(fixCards);
    }

    function start() {
      var handle = getHandle();
      isProduct = !!(handle && document.querySelector("variant-selects"));
      var pB = isProduct ? loadProduct(handle) : Promise.resolve();
      var pA = queryHandles(collectHandles());
      Promise.all([pA, pB]).then(function () {
        if (isProduct) applyDetail();
        fixCards();
        var mo = new MutationObserver(function () { schedule(); maybeQueryNew(); });
        mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ["class", "disabled"] });
        document.addEventListener("change", function (e) {
          if (e.target && e.target.matches && e.target.matches('variant-selects input[type="radio"]')) schedule();
        }, true);
      }).catch(function () {});
    }

    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
    else start();
  } catch (err) { /* silent — 스토어프론트 안 깨지게 */ }
})();
